module.exports = __webpack_public_path__ + "staticmedia/media/KNET-Logo.0d0b50eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/KNET-Logo.svg
// module id = 556
// module chunks = 0